import styled from "styled-components";

export default styled.article`
  .image-card {
    background-color: blue;
    width: 100%;
    border-radius: 20px;
    position: relative;
    overflow: hidden;
    min-height: 100%;

    .card-content {
      position: absolute;
      padding: 0.5rem;
      z-index: 1;
      display: flex;
      height: 100%;
      align-items: flex-end;
      pointer-events: none;

      & :global(*) {
        line-height: 120%;
      }
    }
  }

  .shadow {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgb(49, 50, 53);
    background: linear-gradient(
      180deg,
      rgba(49, 50, 53, 0) 0%,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.10407913165266103) 47%,
      rgba(0, 0, 0, 0.3337710084033614) 66%,
      rgba(0, 0, 0, 1) 100%
    );
  }

  .small {
    grid-row: span 1;
  }

  .big {
    grid-row: span 2;
  }

  .text-card {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-right: 1rem;

    & > * {
      line-height: 1.5rem;
    }

    & > .next-link {
      display: inline-flex;
      justify-content: flex-start;
      padding: 0;
      background-color: transparent !important;
      border-color: transparent !important;
    }
  }

  .module-container {
    .grid-layout {
      row-gap: 1rem;
      padding-top: 1rem;

      .image-cards {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr 1fr 1fr;
        grid-auto-flow: column;
        gap: 0.5rem;
      }
    }
  }

  .inline-container {
    .inline-layout {
      row-gap: 1rem;
      padding-top: 1rem;

      .image-cards {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr 1fr;
        grid-auto-flow: row;
        gap: 0.5rem;
      }
    }
  }

  @media screen and (min-width: 760px) {
    .image-card {
      .card-content {
        padding: 1rem;
      }
    }

    .module-container {
      .grid-layout {
        .image-cards {
          grid-auto-flow: column;
          grid-template-columns: 1fr 1fr 1fr;
          grid-template-rows: 1fr 1fr;
        }
      }
    }

    .inline-container {
      .inline-layout {
        .image-cards {
          grid-auto-flow: row;
          grid-template-columns: 1fr 1fr 1fr;
          grid-template-rows: 1fr;
        }
      }
    }
  }

  @media screen and (min-width: 1024px) {
    .module-container {
      .grid-layout {
        .image-cards {
          &--reverse {
            order: -1;
          }
          gap: 1.5rem;
        }
      }
    }

    .inline-container {
      .inline-layout {
        .image-cards {
          gap: 1.5rem;

          &--reverse {
            order: -1;
          }
        }
      }
    }
  }
`;
